import { useTranslation } from 'react-i18next';
import { Circle, HStack } from 'native-base';
import { Text } from '@pimm/base';

export const NetworkBadge = ({ status = 'offline' }: { status: string }) => {
  const { t } = useTranslation();
  const normalized = status.toLowerCase();
  const color = normalized === 'offline' ? 'error' : 'success';
  const label = normalized === 'offline' ? t('delivery_monitor:offline') : t('delivery_monitor:online');
  return (
    <HStack
      px={2}
      w="70px"
      h={6}
      alignItems="center"
      justifyContent="center"
      backgroundColor={`${color}.50`}
      borderColor={`${color}.200`}
      rounded="md"
      space={1}
    >
      <Circle size="8px" bgColor={`${color}.600`} />
      <Text size="sm" color={`${color}.600`} fontWeight={500} textAlign="center" lineHeight="xs">
        {label}
      </Text>
    </HStack>
  );
};
